<style lang="less">
@import url("../../stylesheet/variable.less");
.goods-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 2.66vw;
  .img-wrap {
    position: relative;
    .rapidAfterSales-image {
      width: 7.2vw;
      position: absolute;
      right: 5px;
      top: 5px;
      z-index: 3;
    }
    .labels {
      position: absolute;
      bottom: 0;
      left: 0;
      .item-common-label {
        margin-right: 5px;
        color: #fff;
        float: left;
        padding: 0 8px;
        font-size: 10px;
        height: 15px;
        line-height: 15px;
        border-radius: 1px;
      }
    }
    .buyer-label {
      position: absolute;
      top: 5px;
      color: #bca27d;
      width: 16px;
      font-size: 9px;
      text-align: center;
      padding: 4px 2px;
      left: 5px;
      line-height: 11px;
      background-color: rgba(255, 255, 255, 0.8);
      &::before {
        .setBorderLineWithoutRadius(#bca27d);
      }
    }
  }
  .product-count {
    display: flex;
    align-items: center;
    color: #191a1b;
  }
  .origin-price {
    // 保证现价全部展示
    text-overflow: clip !important;
  }
  .goods-item {
    width: 46vw;
    margin-bottom: 2.7vw;
    background: #fff;

    .item-describe {
      margin-top: 8px;
      margin-bottom: 2.7vw;
      
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .masterName {
        color: @textGrey;
        font-size: 14px;
        white-space: normal;
        margin-bottom: 3px;
        display: -webkit-box;
        word-break: break-all;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        .country-image-label {
          width: 20px;
          height: 13px;
          display: block;
        }
        span {
          vertical-align: middle;
          display: inline-block;
          height: 15.5px;
        }
      }
      .slaveName {
        font-size: 12px;
        margin-bottom: 2px;
        color: rgb(121, 125, 130);
      }
      .price,
      .marketPrice {
        display: inline-block;
        vertical-align: text-top;
      }
      .marketPrice {
        text-decoration: line-through;
      }
      .pintuan_img {
        width: 35px;
        height: 11px;
      }
      .priceList {
        position: relative;
        display: flex;
        align-items: center;
        .cart-btn {
          position: absolute;
          right: 0;
          top: 0;
          width: 23px;
          height: 23px;
          img {
            width: 23px;
            height: 23px;
          }
        }
      }
    }
  }
  .goods-item:nth-child(2n-1) {
    margin-right: 2.6vw;
  }
  .goods-item:nth-last-child(1) {
    margin-bottom: 0px !important;
  }
  .goods-item:nth-last-child(2) {
    margin-bottom: 0px !important;
  }
  .goods-item-hidden {
    visibility: hidden;
  }
}
.course-list {
  background: #f4f4f4;
  .goods-item {
    background: #fff;
    width: 44.8vw;
    padding: 2.6vw;
    box-sizing: border-box;
    margin-bottom: 2.7vw;
    .course-attr {
      color: #666666;
      font-size: 12px;
      margin-top: 1.2vw;
    }
    .item-describe > .masterName {
      margin-bottom: 11px;
      min-height: 3em;
    }
  }
  .goods-item:nth-child(2n-1) {
    margin-right: 2.4vw;
  }
}
</style>
<template>
  <ul :class="['goods-list', isCourseProduct ? 'course-list' : '']">
    <li
      v-for="(item, i) in goodsList"
      :class="['goods-item border-radius-8', item.skuId === -99 ? 'goods-item-hidden' : '']"
      :key="item.skuId"
      v-track="
        viewTrackData
          ? {
              act: 'view',
              id: viewTrackData.trackId,
              data: {
                aId: viewTrackData.algorithmId + '' || '0',
                bId: viewTrackData.bId ? viewTrackData.bId + '' : '',
                spuIds: [
                  item.id + ''
                ]
              },
            }
          : ''
      "
      @click="clickGoodsItem(i, item.id)"
    >
      <div class="item-wrap">
        <div class="img-wrap">
          <img class="rapidAfterSales-image" :src="item.rapidAfterSalesImage" />
          <isSoldout
            :width="imgStyle.width"
            :height="imgStyle.height"
            :src="item.imgUrl"
            :isSold="item.totalInventory == 0"
          ></isSoldout>
          <span class="labels">
            <div
              class="item-common-label"
              v-for="(l, index) in item.commonLabel"
              :style="`background-color:${l.labelColor}`"
              :key="index"
            >
              {{ l.title }}
            </div>
          </span>
          <div class="buyer-label" v-if="item.buyerLabel">
            {{ item.buyerLabel }}
          </div>
        </div>
        <div class="item-describe padding-lr-10">
          <div class="masterName">
            <span v-if="item.countryImage && !isProductDetailCommend">
              <img class="country-image-label" :src="item.countryImage" />
            </span>
            <span v-if="item.hasVideo == 1">
              <img
                class="country-image-label"
                src="../../image/buyer/iconPlay.png"
              />
            </span>
            {{ item.masterName }}
          </div>

          <!-- <div
            class="slaveName"
            v-if="!isProductDetailCommend && !isCourseProduct"
          >
            {{ item.slaveName || '' }}
          </div> -->
          <!-- 商品聚合预览页需要展示商品的数量 -->
          <div
            v-if="isProductTemplatePreview"
            class="product-count"
          >
            数量 * {{ item.count }}
          </div>

          <div class="priceList" v-if="!isHidePrice">
            <price
              :style="{ marginRight: '2px' }"
              class="price origin-price"
              :originPrice="item.price"
              intSize="15"
              fracSize="10"
            ></price>
            <!-- 拼团价格的显示 -->
            <price
              v-show="!!item.groupPrice"
              class="price"
              :originPrice="item.groupPrice"
              intSize="13"
              fracSize="13"
            ></price>
            <price
              class="marketPrice"
              v-show="
                (!item.groupPrice || item.groupPrice == 0) &&
                item.marketPrice > 0 &&
                item.marketPrice > item.price
              "
              :originPrice="item.marketPrice"
              intSize="11"
              fracSize="11"
              color="rgb(189, 192, 197)"
            ></price>

            <!-- <div class="course-attr" >含20节课程</div> -->
            <!-- 拼团图片 -->
            <div :style="{ display: 'inline-block', marginLeft: '-3px' }">
              <img
                v-show="!!item.groupPrice"
                class="pintuan_img"
                src="../../image/global/two_people_pintuan.png"
                alt="2人拼团图片"
              />
            </div>

            <div class="cart-btn" @click.stop="addToCard(i)" v-if="isNeedCart">
              <img src="../../image/cart/goodslist-cart.png" alt="" />
            </div>
          </div>

          <div
            class="course-attr"
            v-if="isCourseProduct && item.courseProductAttrText"
          >
            {{ item.courseProductAttrText }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import price from './price';
import lazyImg from './lazy-img';
import isSoldout from './isSoldOut';
import constant from '../constant/home.js';

export default {
  // mixins: [keepAliveMixin],
  props: [
    'goodsList',
    'viewTrackData',
    'isNeedCart',
    'isHidePrice',
    'isProductDetailCommend',
    'showType',
    'isProductTemplatePreview',
  ],
  data() {
    return {
      SHOW_TYPE_COURSE: constant.GOODS_LIST_SHOW_TYPE_COURSE,
    };
  },
  methods: {
    clickGoodsItem(index, id) {
      console.log(this.goodsList[index])
      this.$emit('click-goods-item', index, id);
      if (this.goodsList[index].href) {
        // TODO: 常量化
        if (this.$route.query.giftType == 1) {
          const queryStr = JSON.stringify({
            businessType: 2,
          });
          const temp = Object.assign(this.goodsList[index].href, {
            query: { businessInfo: queryStr },
          });
          this.$router.push(temp);
          return;
        }
        this.$router.push(this.goodsList[index].href);
      }
    },
    addToCard(index) {
      this.$emit('cartChange', this.goodsList[index]);
    },
  },
  computed: {
    isCourseProduct() {
      return this.showType === this.SHOW_TYPE_COURSE;
    },
    imgStyle() {
      if (this.isCourseProduct) {
        return {
          width: '39.5vw',
          height: '22.4vw',
        };
      }
      return {
        width: '46vw',
        height: '46vw',
      };
    },
  },
  components: {
    price,
    lazyImg,
    isSoldout,
  },
};
</script>

